// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__TDxuV","subjectitem":"Dropdown_subjectitem__bq92U","img":"Dropdown_img__DqXv0"};